import { isValidCEP } from '@brazilian-utils/brazilian-utils';

export const zipcodeMessage = 'CEP inválido';

export { isValidCEP as isValidZipcode };
